import posthog from 'posthog-js';
import { installHandledPromiseRejectionGuard } from './handled-promise-rejections.js';

const POSTHOG_INITIALIZED_KEY = '__coachCatalystPosthogInitialized';

function metaContent(name) {
  return document.querySelector(`meta[name="${name}"]`)?.content?.trim();
}

export function initPosthog() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  // Install this before PostHog registers its exception handler so expected
  // Axios rejections (validation failures and cancellations) are not captured.
  installHandledPromiseRejectionGuard();

  if (window[POSTHOG_INITIALIZED_KEY]) return;

  const apiKey = metaContent('posthog-project-api-key');
  if (!apiKey) return;

  const host = metaContent('posthog-host') || 'https://us.i.posthog.com';
  const environment =
    metaContent('posthog-environment') || document.body?.dataset?.environment;
  const distinctId = metaContent('posthog-distinct-id');

  posthog.init(apiKey, {
    api_host: host,
  });

  if (environment) posthog.register({ environment });
  if (distinctId) posthog.identify(String(distinctId));

  window.posthog = posthog;
  window[POSTHOG_INITIALIZED_KEY] = true;
}

export default initPosthog;
